requestAnimationFrame(() => {
  scriptController.executeWhenScriptLoaded('cart.js', () => {
    themeBase.onDOMContentLoadedTrigger(() => {
      if (!customElements.get('free-shipping')) {
        customElements.define(
          'free-shipping',
          class FreeShipping extends HTMLElement {
            constructor() {
              super();

              this.completedClass = 'free-shipping--completed';
              this.info = this.querySelector('.free-shipping__info');
              this.progressBar = this.querySelector('.free-shipping__progress-bar');
              this.totalPrice = this.querySelector('.free-shipping__total-price');
            }

            connectedCallback() {
              this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.update.bind(this));
              this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.update.bind(this));

              if (cartBase.wasUpdate) {
                this.update(this);
              }
            }

            disconnectedCallback() {
              if (this.cartUpdateUnsubscriber) {
                this.cartUpdateUnsubscriber();
              }
              if (this.quantityUpdateUnsubscriber) {
                this.quantityUpdateUnsubscriber();
              }
            }

            update(event) {
              const totalPrice = event?.cartData?.total_price || cartBase?.cartData?.total_price;

              if (totalPrice !== undefined) {
                this.changeState(cartBase.cartData.total_price);
              } else {
                cartBase.getData().then((data) => this.changeState(data.total_price));
              }
            }

            changeState(totalPrice) {
              const leftToSpend = Math.max(window.freeShippingLimit - totalPrice, 0);

              this.info.innerHTML = leftToSpend > 0 ? window.cartStrings.freeShippingHTML.replace(
                  '{{ value }}',
                  new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(leftToSpend / 100) + ' euros'
                ) :
                window.cartStrings.freeShippingCompleteHTML;
              this.progressBar.style.width = `${Math.min(totalPrice / (window.freeShippingLimit / 100), 100)}%`;
              this.totalPrice.innerHTML = Shopify.formatMoney(totalPrice);
              this.classList[leftToSpend > 0 ? 'remove' : 'add'](this.completedClass);
            }
          }
        );
      }
    });
  });
});